enum ProductGroup {
    CablesCubage = 'cables-cubage',
    InvertersCubage = 'inverters-cubage',
    ModulesCubage = 'modules-cubage',
    StructuresCubage = 'structures-cubage',
}

export default ProductGroup;
